import React from "react";
import clsx from "clsx";
import LoaderIcon from "@assets/loader_two_arrow.svg";
import styles from "./SpinningLoader.module.scss";
export function SpinningLoader({ className }) {
    return (React.createElement("div", { className: clsx(className, styles.wrap) },
        React.createElement(LoaderIcon, null)));
}
